import React from 'react';
import { ICreateCondition, ConditionTypes, CriteriaTypes } from '@app/models';
import { PersonSharp, Schedule, Devices, PinDrop, Beenhere, MyLocation } from '@material-ui/icons';



export const createConditionTypes = (): ICreateCondition[] => {
    let types: ICreateCondition[] = [];

    types.push({
        label: 'AUTH_POLICY_OBJ_USER',
        value: ConditionTypes.user,
        icon: <PersonSharp />,
        properties: [
            {
                value: CriteriaTypes.signin,
                label: 'AUTH_POLICY_OBJ_USER_SIGNING_IN',
                filter: false
            },
            {
                value: CriteriaTypes.group,
                label: 'AUTH_POLICY_OBJ_USER_GROUPS',
                filter: true,
                chip: 'Groups'
            },
            {
                value: CriteriaTypes.notingroup,
                label: 'AUTH_POLICY_OBJ_USER_NOT_GROUPS',
                filter: true,
                chip: 'NotInGroups',
                chipName: 'Groups'
            },
            {
                value: CriteriaTypes.role,
                label: 'AUTH_POLICY_OBJ_USER_ROLES',
                filter: true,
                chip: 'Roles'
            },
            {
                value: CriteriaTypes.attribute,
                label: 'AUTH_POLICY_OBJ_USER_ATTRIBUTES',
                attribute: true
            }
        ]
    });

    types.push({
        label: 'AUTH_POLICY_OBJ_TIME',
        value: ConditionTypes.currentTime,
        icon: <Schedule />,
        properties: [
            {
                value: CriteriaTypes.before,
                label: 'AUTH_POLICY_OBJ_TIME_BEFORE',
                time: true
            },
            {
                value: CriteriaTypes.after,
                label: 'AUTH_POLICY_OBJ_TIME_AFTER',
                time: true
            }
        ]
    });

    types.push({
        label: 'AUTH_POLICY_OBJ_LOCATION',
        value: ConditionTypes.location,
        icon: <MyLocation />,
        properties: [
            {
                value: CriteriaTypes.country,
                label: 'AUTH_POLICY_LOCATION_COUNTRY',
                list: true
            },
            {
                value: CriteriaTypes.state,
                label: 'AUTH_POLICY_LOCATION_STATE',
                list: true
            },
            {
                value: CriteriaTypes.city,
                label: 'AUTH_POLICY_LOCATION_CITY',
                list: true
            }
        ]
    });

    types.push({
        label: 'AUTH_POLICY_OBJ_IP',
        value: ConditionTypes.ip,
        icon: <PinDrop />,
        properties: [
            {
                value: CriteriaTypes.inrange,
                label: 'AUTH_POLICY_IP_RANGE',
                ip: true
            },
            {
                value: CriteriaTypes.notinrange,
                label: 'AUTH_POLICY_IP_NOT_IN_RANGE',
                ip: true
            }
        ]
    });

    types.push({
        label: 'AUTH_POLICY_OBJ_FORWARD_IP',
        value: ConditionTypes.forwardIP,
        icon: <Beenhere />,
        properties: [
            {
                value: CriteriaTypes.forwardinrange,
                label: 'AUTH_POLICY_IP_RANGE',
                ip: true
            },
            {
                value: CriteriaTypes.forwardnotinrange,
                label: 'AUTH_POLICY_IP_NOT_IN_RANGE',
                ip: true
            }
        ]
    });

    types.push({
        label: 'AUTH_POLICY_OBJ_DEVICE',
        value: ConditionTypes.trustedDevice,
        icon: <Devices />,
        properties: [
            {
                value: CriteriaTypes.trusted,
                label: 'AUTH_POLICY_OBJ_TRUSTED_DEVICE',
                list: false
            },
            {
                value: CriteriaTypes.untrusted,
                label: 'AUTH_POLICY_OBJ_UNTRUSTED_DEVICE',
                list: false
            }
        ]
    });

    return types;
};
